/**
 * Gets the number of user folders from the global Zustand store.
 * @return {number} The number of user folders.
 */
export function getUserFolderAmount(): number {
	const lists = window.valioApp.store.data.lists;

	if ( ! lists ) {
		return 0;
	}

	return Object.values( lists ).length;
}
